import { rm } from 'node:fs/promises';
import type { AuthState } from '@wix/cli-auth';
import { writeCrashReport } from '@wix/cli-debug-log';
import { getTypesDir } from '@wix/velo-github-layout-definitions';
import { getDebugLogFilePath } from '@wix/cli-core-definitions';
import type { ProjectModel } from '../model.js';
import { syncPages } from '../sources/index.js';
import { syncTypesWithAuth } from '../sync-types/index.js';
import type { Logger } from '../logger.js';

export async function syncAllToRevision(
  model: ProjectModel,
  opts: {
    authState: AuthState;
  },
  logger: Logger
) {
  const logTypesSynced = logger.logSyncingTypesToRevision(model.revision);
  try {
    await syncTypesWithAuth(model, { authState: opts.authState });
    logTypesSynced.success();
  } catch (error) {
    // As a workaround until the types sync can handle large projects, this error is recoverable
    writeCrashReport(getDebugLogFilePath(model.projectFolder), error);
    logTypesSynced.fail();
    await rm(getTypesDir(model.projectFolder), {
      recursive: true,
      force: true,
    }).catch((e: unknown) => {
      writeCrashReport(getDebugLogFilePath(model.projectFolder), e);
      logger.logRecoverableFailureToRemoveTypesDir(e);
    });
  }

  const logPagesSynced = logger.logSyncingPagesToRevision(model.revision);
  try {
    await syncPages(model, { authState: opts.authState });
    logPagesSynced.success();
  } catch (error) {
    logPagesSynced.fail();
    throw error;
  }
}
